import { mockHeadData } from 'utils/metaDataUtils/headData';

const Datastore = () => <h1>Hello from Datastore landing page!</h1>;

export const getStaticProps = () => ({
  props: {
    headData: mockHeadData,
  },
});

export default Datastore;
